export function assertIsDefined(val) {
    if (val === undefined || val === null) {
        throw new Error(`Expected 'val' to be defined, but received ${val === undefined ? 'undefined' : 'null'}`);
    }
}
export function assertExhaustive(param) {
    throw new Error(`Invalid exhaustiveness check: ${param}`);
}
//# sourceMappingURL=AssertUtils.js.map